import { useSyncExternalStore } from "react";
const subscribe = () => () => undefined;
export function useHydrated() {
  return useSyncExternalStore(subscribe, _temp, _temp2);
}
function _temp2() {
  return false;
}
function _temp() {
  return true;
}